import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/AuthContext";
import Layout from "@/components/Layout";
import { UpdateBanner } from "@/components/UpdateBanner";
import Login from "@/pages/Login";
import Objekte from "@/pages/Objekte";
import Ideenliste from "@/pages/Ideenliste";
import Stoerung from "@/pages/Stoerung";
import Meldungen from "@/pages/Meldungen";
import RollenStart from "@/pages/RollenStart";
import RollenDetail from "@/pages/RollenDetail";
import DebugLog from "@/pages/DebugLog";
import Dashboard from "@/pages/Dashboard";

function AppRouter() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/objekte" element={<Objekte />} />
        <Route path="/objekte/:liegPermId" element={<Objekte />} />
        <Route path="/meldungen/:permid" element={<Meldungen />} />
        <Route path="/vorgang" element={<Stoerung />} />
        <Route path="/vorgang/:id" element={<Stoerung />} />
        <Route path="/ideen" element={<Ideenliste />} />
        <Route path="/start" element={<RollenStart />} />
        <Route path="/rolle/:role" element={<RollenDetail />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/debug/log" element={<DebugLog />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <UpdateBanner />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
